<template>
  <div>
    <a-spin :spinning="spinning">
      <a-form :form="form">
        <a-form-item label="级别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            disabled
            style="width: 140px"
            placeholder="选择"
            v-decorator="['level', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          >
            <a-select-option :value="1">
              一级类目
            </a-select-option>
            <a-select-option :value="2">
              二级类目
            </a-select-option>
            <a-select-option :value="3">
              三级类目
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['code', {rules: [{ required: true, message: '请输入' }]}]" />
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '请输入'}]}]" />
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="clearfix" style="display: inline-block">
            <a-upload
              name="file"
              accept="image/png, image/jpeg, image/jpg"
              :action="actionUrl"
              v-decorator="['picture', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
              list-type="picture-card"
              :file-list="fileList"
              :data="new_multipart_params"
              :before-upload="beforeUpload"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  图片上传
                </div>
              </div>
            </a-upload>
            <span v-if="false">提示：图片宽高比为1:1</span>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-item>

        <a-form-item
          v-bind="buttonCol"
        >
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { oss_token_list } from '@/api/oss_token'

import { goods_category_update } from '@/api/applet_goods_category'

const fields = ['name', 'level', 'code', 'picture']
export default {
  name: 'GoodsEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      spinning: true,
      id: 0,
      previewVisible: false,
      previewImage: '',
      actionUrl: '',
      fileList: [],
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      }
    }
  },
  beforeCreate () {
    oss_token_list().then(({ data }) => {
      console.log(data, '我是返回值')
      this.new_multipart_params.OSSAccessKeyId = data.accessid
      this.new_multipart_params.policy = data.policy
      this.new_multipart_params.signature = data.signature
      this.actionUrl = 'https://static2.jnzbtz.com'
    })
  },
  mounted () {
    this.$nextTick(() => {
      fields.forEach(v => this.form.getFieldDecorator(v))
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    loadEditInfo (data) {
      const { form } = this
      this.id = data.id
      const formData = pick(data, fields)
      console.log('formData', formData, fields)
      this.fileList = formData.picture
        ? [{
          url: formData.picture,
          uid: '1',
          name: 'xxx.png',
          status: 'done',
          response: 'Server Error 500'
        }]
        : []
      form.setFieldsValue(formData)
      this.spinning = false
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          if (!this.checkValuesIsOk(values)) {
            this.$message.warning('层级和编号长度不对应')
            this.confirmLoading = false
            return
          }
          goods_category_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    checkValuesIsOk (values) {
      return values.code.length === values.level * 2
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    beforeUpload (file) {
      const name = file.name
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      this.new_multipart_params.key = file.uid + '.' + suffix
      // this.form.setFieldsValue({ icon_url: this.new_multipart_params.key })
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('你只能上传jpeg/png格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('文件过大，请重新上传')
      }
      console.log('--------------------------------------', isJpgOrPng, isLt2M)
      return isJpgOrPng && isLt2M
    },
    // 进口图片
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj, () => {
        })
      }
      console.log('我要预览', file)
      this.previewImage = file.url || file.preview || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList, file }) {
      this.fileList = fileList
      if (file.status === 'removed') {
        this.form.setFieldsValue({ picture: '' })
        this.$message.error('请重新上传')
      }
      if (file.status === 'done') {
        this.form.setFieldsValue({ picture: this.actionUrl + '/' + this.new_multipart_params.key })
      }
    },
    handleCancel: function () {
      this.previewVisible = false
    }
  }
}
</script>
